import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

interface UserNameForm {
  userName: FormControl<string>;
}

export interface UserNameSettings {
  userName: string;
}

@Component({
  selector: 'app-change-user-name',
  templateUrl: './change-user-name.component.html',
})
export class ChangeUserNameComponent {
  changeUserName: FormGroup<UserNameForm>;
  constructor(
    private matDialogRef: MatDialogRef<ChangeUserNameComponent>,
    @Inject(MAT_DIALOG_DATA) public data: UserNameSettings,
  ) {
    this.changeUserName = new FormGroup<UserNameForm>({
      userName: new FormControl('', [Validators.required]),
    });
  }
  onOkPressed() {
    this.matDialogRef.close(this.changeUserName.value.userName);
  }
  onCancel() {
    this.matDialogRef.close(null);
  }
}
